import { apiRequest } from '@/utils/api-request';

export interface ClientApiKey {
  id: string;
  orgid: string;
  key_name: string;
  service_name: string;
  description: string;
  api_key: string;
  active: boolean;
  environment?: string;
}

export interface ClientApiKeyUpsert {
  key_name: string;
  service_name: string;
  description: string;
  api_key?: string;
  active: boolean;
}

export const getClientApiKeys = async (orgId: string) => {
  return apiRequest<ClientApiKey[]>({
    url: `/client-api-keys/${orgId}`,
    method: 'GET',
    target: 'platform',
  });
};

export const upsertClientApiKey = async (
  orgId: string,
  payload: ClientApiKeyUpsert,
) => {
  return apiRequest<ClientApiKey>({
    url: `/client-api-keys/${orgId}`,
    method: 'POST',
    target: 'platform',
    body: payload as unknown as Record<string, unknown>,
  });
};

export const deleteClientApiKey = async (orgId: string, keyId: string) => {
  return apiRequest({
    url: `/client-api-keys/${orgId}/${keyId}`,
    method: 'DELETE',
    target: 'platform',
  });
};
